import { combineReducers } from 'redux';

import { RECEIVE_VIDEO_SOURCE, RECEIVE_MEDIA_SOURCE } from '../../actions/ActionTypes';
import { getMedia } from '../../utils/ASVPUtils';

/* VIDEO SOURCE DATA */
// metadata about the video playing -- titles, types, ids, and images

const authReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.auth;
        default:
            return state;
    }
};


const collectionTitleReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.collection_title;
        default:
            return state;
    }
};


const titleReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.title;
        default:
            return state;
    }
};


const titleIdReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.title_id;
        default:
            return state;
    }
};


const mediaIdReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.media_id || null;
        default:
            return state;
    }
};


const launchDateReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            const launchDate = action.payload.data.video.launch_date;
            const authLaunchDate = action.payload.data.video.auth_launch_date;

            return (action.payload.data.video.auth) ? authLaunchDate : launchDate;
        default:
            return state;
    }
};


const typeReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.type;
        default:
            return state;
    }
};


const idReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.id;
        default:
            return state;
    }
};


const posterReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.poster;
        default:
            return state;
    }
};


/* MEDIA SOURCE DATA */
// Includes data about the media itself - duration, media url, whether or not it has captions, and whether it requires cdn token service for playback


const durationReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            const media = getMedia(action.payload);
            return media.totalRuntime;
        default:
            return state;
    }
};


const contentURLReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            const media = getMedia(action.payload);
            return media.secureUrl;
        default:
            return state;
    }
};


const hasCaptionsReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            const media = getMedia(action.payload);
            return !!media.captions && !!media.captions.length;
        default:
            return state;
    }
};


export default combineReducers({
    auth: authReducer,
    collectionTitle: collectionTitleReducer,
    duration: durationReducer,
    id: idReducer,
    poster: posterReducer,
    contentURL: contentURLReducer,
    title: titleReducer,
    titleId: titleIdReducer,
    mediaId: mediaIdReducer,
    launchDate: launchDateReducer,
    type: typeReducer,
    hasCaptions: hasCaptionsReducer,
});


// WEBPACK FOOTER //
// ./src/player/videoSource/reducer.js